module.exports = __webpack_public_path__ + "logo-dc3fc2536bddbc72213bb13245d0170e.png";